const getFromLocalStorage = (franchisor, key) => {
	return localStorage.getItem(getKeyNameForFranchisor(franchisor, key));
};

const getKeyNameForFranchisor = (franchisor, key) => {
	return franchisor && franchisor.subdirectory ? `${franchisor.subdirectory}:${key}` : key;
}

const setToLocalStorage = (franchisor, key, value) => {
	return localStorage.setItem(getKeyNameForFranchisor(franchisor, key), value);
};

const removeFromLocalStorage = (franchisor, key) => {
	return localStorage.removeItem(getKeyNameForFranchisor(franchisor, key));
};

const getFromSessionStorage = (franchisor, key) => {
	return sessionStorage.getItem(getKeyNameForFranchisor(franchisor, key));
};

const setToSessionStorage = (franchisor, key, value) => {
	return sessionStorage.setItem(getKeyNameForFranchisor(franchisor, key), value);
};

const removeFromSessionStorage = (franchisor, key) => {
	return sessionStorage.removeItem(getKeyNameForFranchisor(franchisor, key));
};

export default {
	getFromLocalStorage,
	setToLocalStorage,
	removeFromLocalStorage,
	getFromSessionStorage,
	setToSessionStorage,
	removeFromSessionStorage,
	getKeyNameForFranchisor
};